import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HomeSidebar() {
  const hotArticles = articles
    .filter((a) => a.isHot || a.isTop)
    .sort((a, b) => b.views - a.views)
    .slice(0, 6);

  const recentArticles = articles
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 5);

  return (
    <aside className="space-y-6">
      <div className="bg-background-100/70 rounded-lg p-5 border border-background-200/70">
        <div className="flex items-center gap-2 mb-4">
          <i className="ri-fire-line text-accent-500 text-lg"></i>
          <h3 className="text-base font-heading font-bold text-foreground-950">热门榜单</h3>
        </div>
        <div className="space-y-3">
          {hotArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex items-start gap-3 group cursor-pointer"
            >
              <span
                className={`flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                  index < 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {index + 1}
              </span>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h4>
                <span className="text-xs text-foreground-400 mt-1 block">
                  {(article.views / 10000).toFixed(1)}万阅读
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="bg-background-100/70 rounded-lg p-5 border border-background-200/70">
        <div className="flex items-center gap-2 mb-4">
          <i className="ri-time-line text-secondary-500 text-lg"></i>
          <h3 className="text-base font-heading font-bold text-foreground-950">最新发布</h3>
        </div>
        <div className="space-y-3">
          {recentArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="block group cursor-pointer"
            >
              <h4 className="text-sm font-medium text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200">
                {article.title}
              </h4>
              <span className="text-xs text-foreground-400 mt-1 block">{article.date}</span>
            </Link>
          ))}
        </div>
      </div>

      <div className="bg-gradient-to-br from-primary-500/10 to-accent-500/10 rounded-lg p-5 border border-primary-200/30">
        <div className="text-center">
          <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center mx-auto mb-3">
            <i className="ri-mail-send-line text-primary-500 text-lg"></i>
          </div>
          <h3 className="text-sm font-heading font-bold text-foreground-950 mb-1">有料要爆？</h3>
          <p className="text-xs text-foreground-500 mb-3">
            欢迎向我们提供独家爆料线索
          </p>
          <Link
            to="/about"
            className="inline-block text-xs font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap"
          >
            立即联系 &rarr;
          </Link>
        </div>
      </div>
    </aside>
  );
}